import React from 'react'

import { SearchModal } from '../common/search'
import { NavBar } from '../common'
import { Spirit } from '../../styles/spirit-styles'
import HomeHeaderBox from './HomeHeaderBox'

// Custom headings must be React components. You should include the <NavBar /> component
// somewhere in it. You can optionally set the theme of the navbar to `dark` or `light`.
const HomeHeader = () => (
    <div className="gh-bg-home bb b--whitegrey">
        <header className="top-0 left-0 right-0 z-9999">
            <NavBar theme="light" />
        </header>
        <div className={`${Spirit.page.xl} pb5 pt10 pt15-ns pt20-l pb10-ns pb15-l flex flex-column items-center bt bn-ns b--white-10`}>
            <h1 className="ma0 pa0 f2 f1-ns f-headline-l white header-heading-shadow">产品企划工具包（Toolkits for Product Plan）</h1>
            <SearchModal isHome />

            <section className="grid-12 gutter-row-20 gutter-36-ns mt10 mt20-ns mt25-l miw-100 miw-auto-ns home-main-box-margin-ns z-999">
                <HomeHeaderBox
                    to="/concepts/product-strategy-setting-your-strategic-vision-for-product-offerings_zh_CN"
                    title="起步"
                    icon="rocket"
                    color="purple"
                >
                    产品企划（策略规划）描绘了产品最终的愿景，产品的终止之地。通过构建产品策略，你可以决定产品的努力方向。
                </HomeHeaderBox>

                <HomeHeaderBox
                    to="/"
                    title="指南"
                    icon="blocks"
                    color="blue"
                >
                    产品企划涉及到很多相关的主题，如：策略、市场营销、销售等。
                </HomeHeaderBox>

                <HomeHeaderBox
                    to="/"
                    title="模版"
                    icon="typing"
                    color="tutorial-green"
                >
                    获取产品企划相关的工作模版，包括工作检核表、流程图等。
                </HomeHeaderBox>
            </section>
        </div>
    </div>
)

export default HomeHeader
